<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  multiTemplateDataRows
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef>{{ 'common.appName' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container [ngSwitch]="item.name">
        <span *ngSwitchCase="'Authy'">{{ 'account.dialogs.mfa.setup.authy' | t }}</span>
        <span *ngSwitchCase="'Google Authenticator'">{{ 'account.dialogs.mfa.setup.google' | t }}</span>
        <span *ngSwitchCase="'LastPass Authenticator'">{{ 'account.dialogs.mfa.setup.lastPass' | t }}</span>
        <span *ngSwitchCase="'Microsoft Authenticator'">{{ 'account.dialogs.mfa.setup.microsoft' | t }}</span>
        <span *ngSwitchCase="'Simple 2FA Authenticator'">{{ 'account.dialogs.mfa.setup.simple2fa' | t }}</span>
        <span *ngSwitchDefault>{{ item.name }}</span>
      </ng-container>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="confirmed">
    <mat-header-cell *matHeaderCellDef>{{ 'common.status' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container [ngSwitch]="true">
        <mat-chip outlined size="sm" class="activated-chip" *ngSwitchCase="item.confirmed">
          <div class="activated-chip-label">
            <span>{{ 'common.activated' | t }}</span>
          </div>
        </mat-chip>
        <mat-chip outlined size="sm" class="unconfirmed-chip" *ngSwitchCase="!item.confirmed">
          <div class="unconfirmed-chip-label">
            <span>{{ 'account.dialogs.mfa.unconfirmed' | t }}</span>
          </div>
        </mat-chip>
      </ng-container>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysCollapse></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
